import { IWCCContentBlock } from "components/content/blocks/block/block.interfaces";
import { wccModules } from "enums/wccModules";
import { inject, injectable } from "inversify";
import './block.scss';

@injectable()
export default class WCCContentBlockVM {
    constructor(
        @inject(wccModules.componentConfig) block: IWCCContentBlock,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        ko.applyBindingsToNode(info.element, {
            'css': {
                'content-block--inline-embed': block.type == 'inline-embed',
                'content-block--inline': block.type == 'inline',
                'content-block--embed': block.type == 'embed'
            }
        });
    }
}